import { ToolSelector } from './components/ToolSelector';

export interface Step3Data {
  tools: string[];
}

export function WizardStep3({
  data,
  onPatch,
}: {
  data: Step3Data;
  onPatch: (patch: Partial<Step3Data>) => void;
}) {
  return (
    <div style={{ paddingBottom: 100 }}>
      <ToolSelector selected={data.tools} onChange={(tools) => onPatch({ tools })} />
    </div>
  );
}
